import { Controller } from "@hotwired/stimulus"

// Example chips that drop their text into an input.
//   <div data-controller="fill-input">
//     <input data-fill-input-target="input">
//     <button type="button" data-action="click->fill-input#set" data-value="…">
export default class extends Controller {
  static targets = ["input"]

  set(event) {
    this.inputTarget.value = event.currentTarget.dataset.value
    this.inputTarget.dispatchEvent(new Event("input", { bubbles: true }))
    this.inputTarget.focus()
  }
}
